import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

import { MedIconHorizontalAlignCenterComponent } from "./med-icon-horizontal-align-center.component";

@NgModule({
  declarations: [
    MedIconHorizontalAlignCenterComponent,
  ],
  imports: [
    CommonModule,
  ],
  exports: [
    MedIconHorizontalAlignCenterComponent,
  ],
})
export class MedIconHorizontalAlignCenterModule { }
